export default __webpack_public_path__ + "static/media/amazonHomePage.1f12c41b.jpg";